var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeven({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.191406 0.280151H37.8396V36.7398H0.191406V0.280151Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H38V36.9227H0V0Z",
    fill: "#008061"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4281 34.4934V35.9717H14.314V34.4907H7.41725C6.74336 34.4907 6.19444 33.7863 6.19444 32.9179L3.30859 3.73148C3.30859 2.86249 3.98248 2.15759 4.81403 2.15759H32.6835C33.5097 2.15759 34.1835 2.8625 34.1835 3.73148L31.3303 32.9179C31.3303 33.7863 30.7813 34.4907 30.1075 34.4907L23.4281 34.4934Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.38477 6.43091H27.0424C25.2054 7.11951 19.6131 10.9059 18.2164 13.4516H8.40113L8.38477 6.43091Z",
    fill: "#F5821F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2567 26.5477C22.9904 29.0902 22.9795 32.1863 22.9795 35.4385H14.8926C14.8926 32.1863 15.0285 29.0902 15.2947 26.5477H23.2567Z",
    fill: "#ED1B2D"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7456 22.8738V23.8591H9.45217V24.8449H10.7456V25.9744H7.78906V20.7184H10.7456V21.8891H9.45217V22.8738H10.7456Z",
    fill: "#008061"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6189 22.8738V23.8591H16.331V24.8449H17.6189V25.9744H14.668V20.7184H17.6189V21.8891H16.331V22.8738H17.6189Z",
    fill: "#008061"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.1968 22.8738V23.8591H23.9033V24.8449H25.1968V25.9744H22.2402V20.7184H25.1968V21.8891H23.9033V22.8738H25.1968Z",
    fill: "#008061"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9619 20.7184V24.8449H14.2552V25.9744H11.2988V20.7184H12.9619Z",
    fill: "#008061"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0054 24.2707L19.3748 20.7184H17.9238L18.7498 25.9744H20.8857L21.8857 20.7184H20.652L20.0054 24.2707Z",
    fill: "#008061"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8965 20.7184H27.4945V25.9738H25.8965V20.7184Z",
    fill: "#008061"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4941 22.2787C27.5812 21.7032 28.3963 21.8575 28.3963 22.1863V25.9743H29.9996V21.5195C29.9996 20.5749 28.6681 20.195 27.505 21.0265L27.4941 22.2787Z",
    fill: "#008061"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0051 19.9792C24.1681 17.9678 26.9235 14.683 29.592 13.8205V6.06067C22.2497 9.34552 17.4779 14.3135 16.4453 19.9596L24.0051 19.9792Z",
    fill: "#ED1B2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeven);
export default __webpack_public_path__ + "static/media/seven.28f2b796b83737ffa3ba4e572fb302bd.svg";
export { ForwardRef as ReactComponent };